import React, {useContext,useEffect,useState} from 'react'
import { SectionContext } from "../context/sectionContext"
import { ErrorContext } from "../context/errorContext"
import { ConditionContext } from "../context/conditionContext"
import {JourneyContext} from "../context/journeyContext"
import { Swiper, SwiperSlide } from "swiper/react"
import { getValueFromJourney } from '../services/helperFunctions'
import { lineCapital } from '../../shared/functions'
import "swiper/swiper.min.css"
import "swiper/components/navigation/navigation.min.css"
import SwiperCore, { Navigation } from "swiper/core"
SwiperCore.use([Navigation])
export default function ComponentCheckbox(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!sectionState.sectionData?.[props.data.formControlKey]) {
        if (props.data.isChecked) {
          if (sectionState.sectionId === props.sectionId) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: props.data.isChecked,
                },
              }
            })
          } else {
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: props.sectionId,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: props.data.isChecked,
                },
              }
            })
          }
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: props.data.isChecked,
            }
          })
        }
     
    }else{
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
        }
      })
    }
  }, [])

  const validate = (target, nextValue = null) =>  {
    const resolvedValue =
      nextValue !== null
        ? nextValue
        : sectionState.sectionData?.[props.data.formControlKey]
    if(props.data.required){ // required field validation
      if((resolvedValue === "") || (!resolvedValue)){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: props.data.requiredError
            ? (getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.requiredError
            )): `Error Code Not Found in Strapi`,
          })
        })
      }else{
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
      // if(target.value){
      //   setErrorState(prev => {
      //     return({
      //       ...prev,
      //       [props.data.formControlKey]: ""
      //     })
      //   })
      // }
    }
    return
  }

  useEffect(()=>{
    validate({value: sectionState.sectionData?.[props.data.formControlKey]?? ""})
  },[sectionState.sectionData?.[props.data.formControlKey]])

  const handleChange = target => {
    const nextValue = sectionState.sectionData[props.data.formControlKey]
      ? !sectionState.sectionData[props.data.formControlKey]
      : true
    if (nextValue) {
      setErrorState(prev => ({
        ...prev,
        [props.data.formControlKey]: "",
      }))
    }
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: nextValue 
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: nextValue 
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: nextValue 
      }
    })
    validate(target, nextValue)
  }
  return (
    <>
      <div style={{overflow: "hidden", width: "100%"}}>
        <input
          type="checkbox"
          style={{
            width: "25px",
            height: "25px",
            display: "block",
            float: "left"
          }}
          checked={sectionState?.sectionData[props.data.formControlKey]}
          onChange={handleChange}
        />
        <div dangerouslySetInnerHTML={{ "__html": props.data.html }} style={{display: "block", float: "right", width: "calc(100% - 50px)"}}></div>
      </div>

      <span className="input-error2" style={{marginLeft: "50px"}}>
        {props.showError && errorState[props.data.formControlKey]}
      </span>
    </>
  )

}